import { Application, ApplicationManifest } from 'models'

export enum ApplicationViewState {
  Loading = 'loading',
  UnknownIntegration = 'unknownIntegration',
  NotFound = 'notFound',
  Connect = 'connect',
  Redirecting = 'redirecting',
  Failed = 'failed',
  PendingReturn = 'pendingReturn',
  Configure = 'configure'
}

export interface ApplicationViewStateInput {
  loading: boolean
  /* Create or retry answered; the browser is on its way to the provider. */
  redirecting: boolean
  /* The id in the address answered 404. */
  notFound: boolean
  manifest: ApplicationManifest | null
  applicationId?: string
  application: Application | null
}

/* The one place the page's step and state are decided. The callback's query string is deliberately
 * not an input: the connection block is the only truth, so a reload lands on the same state. */
export const deriveViewState = ({
  loading,
  redirecting,
  notFound,
  manifest,
  applicationId,
  application
}: ApplicationViewStateInput): ApplicationViewState => {
  if (loading) return ApplicationViewState.Loading
  if (!manifest) return ApplicationViewState.UnknownIntegration
  if (notFound) return ApplicationViewState.NotFound
  if (redirecting) return ApplicationViewState.Redirecting
  if (!applicationId || !application) return ApplicationViewState.Connect

  const status = application.connection?.status

  if (status === 'CONNECTED') return ApplicationViewState.Configure
  if (status === 'PENDING') return ApplicationViewState.PendingReturn

  /* `FAILED`, `DISCONNECTED` and a block the backend did not send all land on the error step,
   * the only one offering Try again. */
  return ApplicationViewState.Failed
}
